export const DEPLOY_VERSION = APP_VERSION ?? ''

export default { DEPLOY_VERSION }
